module.exports = __webpack_public_path__ + "img/tech 7.5edc2ec0.png";